export type LabelValSpacing = "none" | "new-line" | "whitespace";

function appendSpacing(spacing: LabelValSpacing) {
  switch (spacing) {
    case "new-line":
      return "\n";
    case "whitespace":
      return " ";
    default:
      return "";
  }
}
export function stringifyLabelVal<ValType extends string | number>(
  label: string,
  val?: ValType,
  spacing: LabelValSpacing = "new-line",
  nullCondition?: string,
) {
  if (val === nullCondition) {
    return "";
  }
  return val ? `${label}: ${val}${appendSpacing(spacing)}` : "";
}

export function stringifyLabelValues<
  ValType extends string | number,
  LabelValues extends [string, ValType],
>(
  labelValues: LabelValues[],
  spacing: LabelValSpacing = "new-line",
  nullCondition?: string,
) {
  return labelValues
    .map((labelVal) =>
      stringifyLabelVal(labelVal?.[0], labelVal?.[1], "none", nullCondition),
    )
    .join(appendSpacing(spacing));
}
